import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { api } from "@/lib/api";
import { toast } from "sonner";

const EMPTY = { job_number: "", customer: "", job_date: "", description: "" };

export const JobPackModal = ({ open, edit, clientSlug, onClose, onSaved }) => {
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) setForm(edit ? { job_number: edit.job_number, customer: edit.customer, job_date: edit.job_date, description: edit.description } : EMPTY);
  }, [open, edit]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async () => {
    if (!form.job_number.trim()) { toast.error("Enter a job number"); return; }
    setBusy(true);
    try {
      const r = edit ? await api.patch(`/job-packs/${edit.id}`, form) : await api.post("/job-packs", { ...form, client_slug: clientSlug });
      toast.success(edit ? "Job pack updated" : "Job pack created");
      onSaved(r.data);
    } catch (e) { toast.error(e.response?.data?.detail || "Could not save"); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="jp-modal" className="sm:max-w-[480px]">
        <DialogHeader>
          <DialogTitle>{edit ? "Edit job pack" : "New job pack"}</DialogTitle>
          <DialogDescription>Group the quote, job card, invoice and other records for one job.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div><Label className="text-xs">Job number</Label><Input data-testid="jp-number-input" value={form.job_number} onChange={set("job_number")} placeholder="e.g. JOB-1042" /></div>
          <div><Label className="text-xs">Job date</Label><Input data-testid="jp-date-input" type="date" value={form.job_date} onChange={set("job_date")} /></div>
          <div className="sm:col-span-2"><Label className="text-xs">Customer</Label><Input data-testid="jp-customer-input" value={form.customer} onChange={set("customer")} placeholder="Customer name" /></div>
          <div className="sm:col-span-2"><Label className="text-xs">Description</Label><Textarea data-testid="jp-description-input" rows={3} value={form.description} onChange={set("description")} placeholder="What the job was" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button data-testid="jp-save-button" className="brand-gradient text-white" disabled={busy} onClick={save}>{busy ? "Saving..." : "Save"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
